/* unplugin-vue-components disabled */import script from "./tableColumnConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./tableColumnConfig.vue?vue&type=script&setup=true&lang=js"

import "./tableColumnConfig.vue?vue&type=style&index=0&id=15a020a2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15a020a2"]])

export default __exports__